import { tempoParaMinutos } from '@/service/api/endpoints/tolerancia'

export type TipoTolerancia = 'semana' | 'dia' | 'turno' | 'registro'

type CampoTolerancia = 'turno' | 'registros' | 'dia'

/** Valor em minutos (formulário) ou `HH:mm` (API) */
type Minutos = string | number | null

type FonteTolerancia = {
    tipo?: string | null
    toleranciaSemana?: Minutos
    tolerancias?: {
        toleranciaDia?: Minutos
        toleranciaTurno?: Minutos
    }
}

const rotulos: Record<TipoTolerancia, string> = {
    semana: 'Por semana',
    dia: 'Por dia',
    turno: 'Por turno',
    registro: 'Por registro',
}

/** Campos que deixam de ser considerados em cada tipo de tolerância */
export const camposIgnorados: Record<TipoTolerancia, CampoTolerancia[]> = {
    semana: ['turno', 'dia', 'registros'],
    dia: ['turno', 'registros'],
    turno: ['dia', 'registros'],
    registro: ['turno', 'dia'],
}

function minutos(valor: Minutos | undefined) {
    return tempoParaMinutos(valor ?? 0) || 0
}

/**
 * Na carga semanal o saldo só é apurado no fim da semana, então as demais
 * tolerâncias não entram no cálculo. Fora dela, por dia tem precedência sobre
 * por turno, que tem sobre por registro.
 */
export function tipoTolerancia(fonte: FonteTolerancia): TipoTolerancia {
    if (fonte.tipo === 'SEMANAL') return 'semana'
    if (minutos(fonte.tolerancias?.toleranciaDia) !== 0) return 'dia'
    if (minutos(fonte.tolerancias?.toleranciaTurno) !== 0) return 'turno'
    return 'registro'
}

const valorPorTipo: Record<
    Exclude<TipoTolerancia, 'registro'>,
    (fonte: FonteTolerancia) => number
> = {
    semana: fonte => minutos(fonte.toleranciaSemana),
    dia: fonte => minutos(fonte.tolerancias?.toleranciaDia),
    turno: fonte => minutos(fonte.tolerancias?.toleranciaTurno),
}

/** Rótulo para listagem, ex.: `Por dia (10 min)` */
export function rotuloTipoTolerancia(fonte: FonteTolerancia) {
    const tipo = tipoTolerancia(fonte)
    if (tipo === 'registro') return rotulos.registro

    return `${rotulos[tipo]} (${valorPorTipo[tipo](fonte)} min)`
}
